export enum gender {
    MALE = 'Male',
    FEMALE = 'Female',
    OTHER = 'Other',
    UNKNOW = 'Unknown'
}
